import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderRanking from "../Components/Ranking/headerRanking";
import ListBuilderRating from "../Components/Ranking/listBuilderRanking";

const RankingRoutes = () => {
  return (
    <Routes>
      <Route path="/ranking" element={<HeaderRanking></HeaderRanking>}></Route>
      <Route path="/ranking_builder_list" element={<ListBuilderRating></ListBuilderRating>}></Route>
    </Routes>
  );
};

export default RankingRoutes;
